import { dataIdFromObject } from '@sketch/graphql-cache'

// Components
import { handleFetchMore } from '@sketch/components'

// Hooks
import { useOnEvent } from '@sketch/utils'

// Types
import { useGetCollectionSharesQuery } from '@sketch/gql-types'
import { ShareSearchFilter } from 'modules/shares/hooks/useSearchFilters'
import { ShareSortOrder } from 'modules/shares/hooks/useSortSettings'
interface UseCollectionProps {
  projectId: string
  collectionId: string
  search?: string
  filters?: ShareSearchFilter[]
  sort: ShareSortOrder
}

// Helpers
const entriesPath = ['project', 'collection', 'shares', 'entries']

export const useCollectionsShares = ({
  projectId,
  collectionId,
  search,
  filters = [],
  sort,
}: UseCollectionProps) => {
  const {
    data,
    loading,
    error,
    fetchMore,
    refetch,
  } = useGetCollectionSharesQuery({
    variables: {
      projectIdentifier: projectId,
      collectionIdentifier: collectionId,
      search: {
        name: search,
        filters,
      },
      after: null,
      sortOrder: sort,
    },
  })

  const after = data?.project.collection.shares.meta.after || null

  const loadMoreHandler = handleFetchMore(fetchMore, entriesPath, {
    dataIdFromObject,
    after,
  })

  useOnEvent('workspaceShareRefresh', ({ collectionIdentifier }) => {
    if (collectionIdentifier === collectionId) {
      refetch()
    }
  })

  return {
    project: data?.project,
    loading,
    error,
    fetchMore: loadMoreHandler,
  }
}
